import { useState, useEffect } from 'react';
import { theme } from '../styles/theme';

const KEY = 'nuled.cookies.accepted.v1';

export function CookieBanner() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShown(true);
    } catch {}
  }, []);

  const close = (val: 'all' | 'essential') => {
    try { localStorage.setItem(KEY, val); } catch {}
    setShown(false);
  };

  if (!shown) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: theme.bg,
      borderTop: `4px solid ${theme.accent}`,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
      zIndex: 95,
      fontFamily: theme.font.sans,
      padding: '20px 24px',
    }}>
      <div style={{
        maxWidth: theme.maxWidth,
        margin: '0 auto',
        display: 'flex',
        gap: 24,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}>
        <div style={{ flex: 1, minWidth: 280, fontSize: 13, color: theme.text, lineHeight: 1.5 }}>
          Usamos cookies para mejorar tu experiencia, recordar tu lista de proyecto y medir tráfico.
          Al continuar aceptas nuestra <a href="/aviso-privacidad" style={{ color: theme.accentDark, fontWeight: 700 }}>Política de Privacidad</a>.
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            onClick={() => close('essential')}
            style={{
              border: `1px solid ${theme.border}`,
              background: theme.bg,
              color: theme.brand,
              padding: '10px 16px',
              fontSize: 12,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: 0.4,
              cursor: 'pointer',
              fontFamily: theme.font.sans,
            }}
          >
            Solo esenciales
          </button>
          <button
            onClick={() => close('all')}
            style={{
              background: theme.accent,
              color: theme.brand,
              border: 'none',
              padding: '10px 20px',
              fontSize: 12,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: 0.4,
              cursor: 'pointer',
              fontFamily: theme.font.sans,
            }}
          >
            Aceptar todas
          </button>
        </div>
      </div>
    </div>
  );
}
